import React, { useEffect, useState, useLayoutEffect } from 'react';
import { Col, Row, Select, Typography, Card, Modal, Tooltip, Table } from 'antd';
import { withRouter } from 'react-router-dom';
import PlateService from '../app/service/plateService';
import CmdService from '../app/service/cmdService';
import AuthContext from '../main/authenticationProvider';
import Loading from "../components/loading";
import AppLayout from '../components/layouts/AppLayout';
import { DeviceCommands } from '../components/device/commands';
import { DeviceConfigurations } from '../components/device/configurations';
import { StatusDescriptions } from '../components/device/descriptions';
import { ControlButtons } from '../components/device/controlButtons';
import ReportsService from '../app/service/reportsService';
import Moment from 'moment';

const { Text } = Typography;

export const OfflineDevice = () => {
    const servicePlate = new PlateService();
    const serviceCmd = new CmdService();
    const reportsService = new ReportsService();
    const auth = new AuthContext();

    const [plates, setPlates] = useState([]);
    const [plateSelected, setPlateSelected] = useState("");
    const [loading, setLoading] = useState(false);
    const [deviceStatus, setDeviceStatus] = useState();
    const [plateStatusLoading, setPlateStatusLoading] = useState(false);
    const [modalCommandsVisible, setModalCommandsVisible] = useState(false);
    const [modalConfigurationsVisible, setModalConfigurationsVisible] = useState(false);
    const [loadingCommands, setLoadingCommands] = useState(true);
    const [commandsProcessing, setCommandsProcessing] = useState([]);
    const [commandsColumnsFinalOne, setCommandsColumnsFinalOne] = useState([]);
    const [commandsColumnsFinalTwo, setCommandsColumnsFinalTwo] = useState([]);
    const [routeStartStatus, setRouteStartStatus] = useState([]);
    const [intervalUpdatePage, setIntervalUpdatePage] = useState();
    const [enableUpdatePage, setEnableUpdatePage] = useState(false);

    const columns = [
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Status</div>
            },
            dataIndex: "key",
            key: "key",
            width: 240,
            align: 'center',
            filterSearch: true,
            render: (_, data) => {
                return <Tooltip title="Status do Dispositivo"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.key}</div></Tooltip>;
            },
        },
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>De</div>
            },
            dataIndex: "before",
            key: "before",
            width: 240,
            align: 'center',
            filterSearch: true,
            render: (_, data) => {
                if (data.key === "Tipo de Bloqueio") {
                    if (data.before === "0") {
                        return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>Seguro</div></Tooltip>;
                    } else if (data.before === "1") {
                        return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>Progressivo</div></Tooltip>;

                    }
                }
                if (data.key === "Bloqueador Embutido" || data.key === "Bloqueio por ID" || data.key === "Pontos de Parada" || data.key === "Roteirizador" || data.key === "Bloqueio por SIM-Card" || data.key === "Situação Jamming" || data.key === "Bloqueio por Remoção do RT") {
                    if (data.before === "0") {
                        return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>OFF</div></Tooltip>;
                    } else if (data.before === "1") {
                        return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>ON</div></Tooltip>;

                    }
                }
                if (data.key === "Tempo de Bloqueio") {
                    return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.before}</div></Tooltip>;
                }
                if (data.key === "Tempo de Parada") {
                    return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.before}</div></Tooltip>;
                }
                if (data.key === "Senha de ignição") {
                    return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.before}</div></Tooltip>;
                }
                if (data.key === "Sensibilidade Jamming") {
                    return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.before}</div></Tooltip>;
                }
                if (data.key === "Habilitado") {
                    return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.before}</div></Tooltip>;
                }
                if (data.key === "Bloqueado") {
                    return <Tooltip title="Antes"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.before}</div></Tooltip>;
                }

            },
        },
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Para</div>
            },
            dataIndex: "after",
            key: "after",
            width: 240,
            align: 'center',
            filterSearch: true,
            render: (_, data) => {
                if (data.key === "Tipo de Bloqueio") {
                    if (data.after === "0") {
                        return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>Seguro</div></Tooltip>;
                    } else if (data.after === "1") {
                        return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>Progressivo</div></Tooltip>;

                    }
                }
                if (data.key === "Bloqueador Embutido" || data.key === "Bloqueio por ID" || data.key === "Pontos de Parada" || data.key === "Roteirizador" || data.key === "Bloqueio por SIM-Card" || data.key === "Situação Jamming" || data.key === "Bloqueio por Remoção do RT") {
                    if (data.after === "0") {
                        return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>OFF</div></Tooltip>;
                    } else if (data.after === "1") {
                        return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>ON</div></Tooltip>;

                    }
                }
                if (data.key === "Tempo de Bloqueio") {
                    return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.after}</div></Tooltip>;
                }
                if (data.key === "Tempo de Parada") {
                    return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.after}</div></Tooltip>;
                }
                if (data.key === "Senha de ignição") {
                    return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.after}</div></Tooltip>;
                }
                if (data.key === "Sensibilidade Jamming") {
                    return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.after}</div></Tooltip>;
                }
                if (data.key === "Habilitado") {
                    return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.after}</div></Tooltip>;
                }
                if (data.key === "Bloqueado") {
                    return <Tooltip title="Depois"><div style={{ color: 'black', fontSize: '14px', fontWeight: 500 }}>{data.after}</div></Tooltip>;
                }
            },
        },
    ]

    let commandsColumnsOne = [
        {
            key: "Habilitado",
        },
        {
            key: "Tipo de Bloqueio",
        },
        {
            key: "Bloqueador Embutido",
        },
        {
            key: "Bloqueio por ID",
        },
        {
            key: "Pontos de Parada",
        },
        {
            key: "Roteirizador",
        },
        {
            key: "Bloqueado",
        },

    ];

    let commandsColumnsTwo = [
        {
            key: "Tempo de Bloqueio",
        },
        {
            key: "Tempo de Parada",
        },
        {
            key: "Bloqueio por Remoção do RT",
        },
        {
            key: "Situação Jamming",
        },
        {
            key: "Sensibilidade Jamming",
        },
        {
            key: "Bloqueio por SIM-Card",
        },
        {
            key: "Senha de ignição",
        },
        {
            key: "Casamento",
        }
    ];


    useEffect(() => {
        getPlates();
    }, []);

    useLayoutEffect(() => {
        let interval = null;
        if (deviceStatus !== null) {
            getStatusCmds(plateSelected);
            if (enableUpdatePage) {
                interval = setInterval(() => {
                    getStatusCmds(plateSelected);
                    getStatusPlateAfterSendCmd(plateSelected);
                }, 5000)
                setIntervalUpdatePage(interval);
            }

        }
        return () => {
            clearInterval(interval);
        }
    }, [deviceStatus, enableUpdatePage]);

    const getPlates = () => {
        setLoading(true);

        servicePlate
            .getPlates()
            .then(response => {
                let opt = [];
                response.data.data.forEach(item => {
                    opt.push({
                        value: item.plate,
                        label: item.plate
                    });
                });

                setPlates(opt);
                setLoading(false);
            })
            .catch(erros => {
                setLoading(false);
                erros && erros.response && auth.verifyAuth(erros.response.status);
            })
    };

    const getStatusPlate = (plate, modalIsVisible) => {
        if (modalIsVisible) {
            setPlateStatusLoading(false);
        } else {
            setPlateStatusLoading(true);
        }

        serviceCmd
            .getStatusPlate(plate)
            .then(response => {
                let promises = servicePlate.getStatusRoutePlate(plate).then((response) => {
                    return response.data.data.routeStartStatus
                }).catch((error) => {
                    console.log("Error", error)
                });

                Promise.resolve(promises).then((result) => {
                    setRouteStartStatus(result)
                });

                setDeviceStatus(response.data.data);
                setPlateStatusLoading(false);
            })
            .catch(erros => {
                setDeviceStatus(false);
                setPlateStatusLoading(false);

                erros && erros.response && auth.verifyAuth(erros.response.status);
            })
    };

    const getStatusPlateAfterSendCmd = (plate) => {

        serviceCmd
            .getStatusPlate(plate)
            .then(response => {
                setDeviceStatus(response.data.data);
            })
            .catch(erros => {
                erros && erros.response && auth.verifyAuth(erros.response.status);
            })
    };


    const getStatusCmds = (plate) => {
        let commands = [];

        let commandSplit = [];
        const filter = {
            "plateStr": plate,
            "startDate": Moment().subtract(22, 'days').format("YYYY-MM-DD HH:mm:ss"),
            "endDate": Moment().add(1, 'days').format("YYYY-MM-DD HH:mm:ss")
        };

        reportsService.getCommands(filter).then((response) => {
            commands = response.data.data.filter((value, index) => value.received === false);
            commands.forEach((value, index) => {

                commandSplit = value.cmdType.split(",");

                commandsColumnsOne.forEach((obj) => {

                    if (deviceStatus != null && value.cmdType.startsWith("$ST")) {

                        if (obj.key === "Tipo de Bloqueio" && commandSplit[11] !== deviceStatus.tipoBlk.toString()) {
                            obj['before'] = deviceStatus.tipoBlk.toString();
                            obj['after'] = commandSplit[11];
                        }
                        if (obj.key === "Bloqueador Embutido" && commandSplit[2] !== deviceStatus.bloqueador.toString()) {
                            obj['before'] = deviceStatus.bloqueador.toString();
                            obj['after'] = commandSplit[2];
                        }
                        if (obj.key === "Bloqueio por ID" && commandSplit[8] !== deviceStatus.idRastreador.toString()) {
                            obj['before'] = deviceStatus.idRastreador.toString();
                            obj['after'] = commandSplit[8];
                        }
                        if (obj.key === "Pontos de Parada" && commandSplit[6] !== deviceStatus.controleParada.toString()) {
                            obj['before'] = deviceStatus.controleParada.toString();
                            obj['after'] = commandSplit[6];
                        }
                        if (obj.key === "Roteirizador" && commandSplit[1] !== deviceStatus.roteirizador.substring(0, 1)) {
                            obj['before'] = deviceStatus.roteirizador.substring(0, 1);
                            obj['after'] = commandSplit[1];
                        }

                    } else if (deviceStatus != null && value.cmdType.startsWith("$CMD") && !value.cmdType.startsWith("$CMD,Link") && !value.cmdType.startsWith("$CMD,Route")) {

                        if (obj.key === "Habilitado" && ((deviceStatus.devicesHabilitado.substring(0, 1) !== "0" && commandSplit[1] !== "Enable" && commandSplit[1] !== "Block" && commandSplit[1] !== "Unblock") || (deviceStatus.devicesHabilitado.substring(0, 1) !== "1" && commandSplit[1] !== "Disable" && commandSplit[1] !== "Block" && commandSplit[1] !== "Unblock"))) {
                            obj['before'] = deviceStatus.devicesHabilitado.substring(0, 1) === "0" ? "Desabilitado" : "Habilitado";
                            obj['after'] = commandSplit[1] === "Disable" ? "Desabilitado" : "Habilitado";
                        }
                        if (obj.key === "Bloqueado" && ((deviceStatus.devicesBloqueado.substring(0, 1) !== "0" && commandSplit[1] !== "Block" && commandSplit[1] !== "Enable" && commandSplit[1] !== "Disable") || (deviceStatus.devicesBloqueado.substring(0, 1) !== "1" && commandSplit[1] !== "Unblock" && commandSplit[1] !== "Enable" && commandSplit[1] !== "Disable"))) {
                            obj['before'] = deviceStatus.devicesBloqueado.substring(0, 1) === "0" ? "Desbloqueado" : "Bloqueado";
                            obj['after'] = commandSplit[1] === "Unblock" ? "Desbloqueado" : "Bloqueado";
                        }
                    }

                });

                commandsColumnsTwo.forEach((obj) => {

                    if (deviceStatus != null && value.cmdType.startsWith("$ST")) {
                        if (obj.key === "Tempo de Bloqueio" && commandSplit[3] !== (deviceStatus.tempoPresenca).toString()) {
                            obj['before'] = (parseFloat(deviceStatus.tempoPresenca) / 10).toString();
                            obj['after'] = (parseFloat(commandSplit[3]) / 10).toString();
                        }
                        if (obj.key === "Tempo de Parada" && commandSplit[7] !== (deviceStatus.tempoParada).toString()) {
                            obj['before'] = (parseFloat(deviceStatus.tempoParada) / 10).toString();
                            obj['after'] = (parseFloat(commandSplit[7]) / 10).toString();
                        }
                        if (obj.key === "Bloqueio por Remoção do RT" && commandSplit[10] !== deviceStatus.faltaStt.toString()) {
                            obj['before'] = deviceStatus.faltaStt.toString();
                            obj['after'] = commandSplit[10];
                        }
                        if (obj.key === "Bloqueio por SIM-Card" && commandSplit[9] !== deviceStatus.remSimcard.toString()) {
                            obj['before'] = deviceStatus.remSimcard.toString();
                            obj['after'] = commandSplit[9];
                        }
                        if (obj.key === "Senha de ignição" && commandSplit[4] !== deviceStatus.senhaIgnicao.toString()) {
                            obj['before'] = deviceStatus.senhaIgnicao.toString();
                            obj['after'] = commandSplit[4];
                        }
                        if (obj.key === "Situação Jamming" && String(commandSplit[5]).charAt(0) !== String(deviceStatus.jamming).charAt(0)) {
                            obj['before'] = String(deviceStatus.jamming).charAt(0);
                            obj['after'] = String(commandSplit[5]).charAt(0);
                        }
                        if (obj.key === "Sensibilidade Jamming" && String(commandSplit[5]).charAt(1) + "" + String(commandSplit[5]).charAt(2) !== String(deviceStatus.jamming).charAt(1) + "" + String(deviceStatus.jamming).charAt(2)) {
                            obj['before'] = String(deviceStatus.jamming).charAt(1) + "" + String(deviceStatus.jamming).charAt(2);
                            obj['after'] = String(commandSplit[5]).charAt(1) + "" + String(commandSplit[5]).charAt(2);
                        }
                    } else if (deviceStatus != null && value.cmdType.startsWith("$CMD,Link")) {
                        if (obj.key === "Casamento" && commandSplit[1] === "Link") {

                            if (Array.isArray(obj['description'])) {
                                const existingItem = obj['description'].find(item => item.key === commandSplit[1] + commandSplit[2]);

                                if (!existingItem) {
                                    obj['description'].push({
                                        key: commandSplit[1] + commandSplit[2],
                                        after: commandSplit[2],
                                    });
                                }
                            } else {
                                obj['description'] = [
                                    {
                                        key: commandSplit[1] + commandSplit[2],
                                        after: commandSplit[2],
                                    },
                                ];
                            }
                        }

                    }

                });
            });

            const finalCommands = commands.filter((value) => !value.cmdType.startsWith("$CMD,Route"))
            setCommandsColumnsFinalOne(commandsColumnsOne);
            setCommandsColumnsFinalTwo(commandsColumnsTwo);
            setCommandsProcessing(finalCommands);
            if (Array.isArray(finalCommands) && finalCommands.length > 0) {
                setEnableUpdatePage(true);
            } else {
                setEnableUpdatePage(false);
                clearInterval(intervalUpdatePage);
            }
            setLoadingCommands(false);
        }).catch((error) => {
            console.log("Error", error);
        })
    }

    const handleSaveModalSettings = () => {
        setModalConfigurationsVisible(false);
        setEnableUpdatePage(true);
        getStatusPlate(plateSelected, false);
        setTimeout(() => {
            getStatusCmds(plateSelected);
        }, 500);
    }

    const handleSaveModalCommands = () => {
        setModalCommandsVisible(false);
        setEnableUpdatePage(true);
        setTimeout(() => {
            getStatusCmds(plateSelected);
        }, 500);
    }

    const handleCloseModalSettings = () => {
        setModalConfigurationsVisible(false);
        getStatusPlate(plateSelected, false);
    }

    return (
        <>
            <AppLayout>
                {loading && (
                    <Loading />
                )}

                <div>
                    <Card title="Dispositivos">
                        <Row gutter={24}>
                            <Col span={24}>
                                <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                    }
                                    onChange={plate => {
                                        setPlateSelected(plate);
                                        getStatusPlate(plate);
                                        getStatusCmds(plate);
                                    }}
                                    placeholder="Selecione uma placa"
                                    options={plates ? plates : null}
                                    style={{ width: '100%' }}
                                />
                            </Col>

                            {plateSelected !== "" && (
                                <>
                                    <Col span={24} style={{ marginTop: "10px" }}>
                                        {
                                            plateStatusLoading ? (
                                                <Loading />
                                            ) :
                                                <>
                                                    <ControlButtons
                                                        plateSelected={plateSelected}
                                                        serviceCmd={serviceCmd}
                                                        getStatusPlate={getStatusPlate}
                                                        setModalCommandsVisible={setModalCommandsVisible}
                                                        setModalConfigurationsVisible={setModalConfigurationsVisible}
                                                        deviceStatus={deviceStatus}
                                                        listCommands={commandsProcessing}
                                                        pauseTimer={modalConfigurationsVisible}
                                                    />
                                                    {deviceStatus ? (
                                                        <>
                                                            <Modal
                                                                title="Comandos"
                                                                closable
                                                                destroyOnClose={true}
                                                                onOk={() => setModalCommandsVisible(false)}
                                                                onCancel={() => setModalCommandsVisible(false)}
                                                                footer={null}
                                                                visible={modalCommandsVisible}
                                                                width={1000}
                                                                style={{ top: 200 }}
                                                            >
                                                                <DeviceCommands plateName={plateSelected} deviceStatus={deviceStatus} save={handleSaveModalCommands} routeStartStatus={routeStartStatus} />
                                                            </Modal>



                                                            <Modal
                                                                title="Configurações"
                                                                closable
                                                                destroyOnClose={true}
                                                                onOk={() => setModalConfigurationsVisible(true)}
                                                                onCancel={handleCloseModalSettings}
                                                                footer={null}
                                                                visible={modalConfigurationsVisible}
                                                                width={750}
                                                                style={{ top: 80}}
                                                            >
                                                                <DeviceConfigurations plateName={plateSelected} deviceStatus={deviceStatus} save={handleSaveModalSettings} routeStartStatus={routeStartStatus} />
                                                            </Modal>

                                                            <StatusDescriptions deviceStatus={deviceStatus} />
                                                        </>
                                                    ) :
                                                        (
                                                            <Text style={{ marginTop: '35px', fontSize: '16px', justifyContent: 'center' }} type="danger">Status não encontrado!</Text>
                                                        )}
                                                </>}
                                    </Col>

                                    <Col span={24}>
                                        {loadingCommands ? (
                                            <Loading />
                                        ) : <>
                                            {commandsProcessing.length === 0 ?
                                                <></>
                                                :
                                                <Col span={24} style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                                                    <Table
                                                        columns={columns}
                                                        size='small'
                                                        dataSource={commandsColumnsFinalOne}
                                                        style={{ marginTop: '5px' }}
                                                        pagination={false}
                                                        rowClassName={(record, index) => {

                                                            if (record.before && record.after) {
                                                                return 'row-dark-commands ';
                                                            }
                                                            if (record.key === "Casamento" && record.description && Array.isArray(record.description)) {
                                                                return 'row-dark-commands ';
                                                            }

                                                        }}
                                                        expandable={{
                                                            expandedRowRender: (record) => (
                                                                <div>
                                                                    {record.description && record.description.map((item) => (
                                                                        <div key={item.key}>
                                                                            <p>Slave: {item.after}</p>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ),
                                                            columnWidth: '10px',
                                                            rowExpandable: (record) => record.key === 'Casamento',
                                                            defaultExpandAllRows: true,
                                                        }}
                                                    >

                                                    </Table>

                                                    <Table
                                                        columns={columns}
                                                        size='small'
                                                        dataSource={commandsColumnsFinalTwo}
                                                        style={{ marginTop: '5px' }}
                                                        pagination={false}
                                                        rowClassName={(record, index) => {

                                                            if (record.before && record.after) {
                                                                return 'row-dark-commands ';
                                                            }
                                                            if (record.key === "Casamento" && record.description && Array.isArray(record.description)) {
                                                                return 'row-dark-commands ';
                                                            }

                                                        }}
                                                        expandable={{
                                                            expandedRowRender: (record) => (
                                                                <div>
                                                                    {record.description && record.description.map((item) => (
                                                                        <div key={item.key}>
                                                                            <p>Slave: {item.after}</p>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ),
                                                            columnWidth: '10px',
                                                            rowExpandable: (record) => record.key === 'Casamento',
                                                            defaultExpandAllRows: true,
                                                        }}
                                                    >

                                                    </Table>
                                                </Col>


                                            }

                                        </>}
                                    </Col>
                                </>
                            )}
                        </Row>
                    </Card>
                </div>
            </AppLayout>
        </>
    );
}

export default withRouter(OfflineDevice)